module.exports = __webpack_public_path__ + "static/100--stacked-area-d312ebadec8351767ddb041f1dfa8df9.png";